// src/components/filter.
import React, { useMemo, useRef, useState } from "react"
import PropTypes from "prop-types"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "../../components/Common/TableContainer"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  Input,
  InputGroup,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
import Select from "react-select"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { useFormik } from "formik"
import * as Yup from "yup"
import { Link } from "react-router-dom"

const MaintainanceContactpendingexecution = () => {
  //Grid form
  const formik = useFormik({
    initialValues: {
      firstname: "",
      email: "",
      password: "",
      city: "",
      state: "",
      zip: "",
      check: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("This field is required"),
      email: Yup.string()
        .email()
        .matches(/^(?!.*@[^,]*,)/)
        .required("Please Enter Your Email"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .matches(RegExp("(.*[a-z].*)"), "At least lowercase letter")
        .matches(RegExp("(.*[A-Z].*)"), "At least uppercase letter")
        .matches(RegExp("(.*[0-9].*)"), "At least one number")
        .required("This field is required"),
      city: Yup.string().required("This field is required"),
      state: Yup.string().required("This field is required"),
      zip: Yup.string().required("This field is required"),
      check: Yup.string().required("This field is required"),
    }),

    onSubmit: values => {
      // console.log("value", values.password);
    },
  })

  const columns = useMemo(
    () => [
      {
        header: "W/O Date",
        accessorKey: "wodate",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Customer Name",
        accessorKey: "custname",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Product",
        accessorKey: "pro",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Total Executions",
        accessorKey: "ttlexe",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Interval",
        accessorKey: "interval",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Attempt Executions",
        accessorKey: "atmtexe",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Total Executions Validity",
        accessorKey: "ttlexevali",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Contact End Date",
        accessorKey: "contactdate",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Payment Status",
        accessorKey: "paysts",
        enableColumnFilter: false,
        enableSorting: true,
      },
    ],
    []
  )

  const data = [
    {
      wodate: "1-1-2024",
      custname: "Anuja Pawar",
      pro: "Product A",
      ttlexe: "10",
      interval: "1 Month",
      atmtexe: "2",
      ttlexevali: "2 Month",
      contactdate: "10-3-2014",
      paysts: "Recived",
    },
  ]

  //usestate
  const flatpickrRef = useRef(null)

  const showValue = () => {
    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.open()
    }
  }

  const closeValue = () => {
    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.close()
    }
  }
  //usestate
  const [selectedGroup, setselectedGroup] = useState(null)

  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    {
      label: "Picnic",
      options: [
        { label: "Mustard", value: "Mustard" },
        { label: "Ketchup", value: "Ketchup" },
        { label: "Relish", value: "Relish" },
      ],
    },
    {
      label: "Camping",
      options: [
        { label: "Tent", value: "Tent" },
        { label: "Flashlight", value: "Flashlight" },
        { label: "Toilet Paper", value: "Toilet Paper" },
      ],
    },
  ]

  //meta title
  document.title = "Data Tables | Skote - React Admin & Dashboard Template"

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Breadcrumbs
          title="Forms"
          breadcrumbItem="Maintainance Contact Pending Execution"
        />
        <Row>
          <Col xl={12}>
            <div className="page-content">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">
                    Date Range of Cold Calling Status
                  </CardTitle>

                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      {" "}
                      <Col xs={3}>
                        <div className="form-group mb-4">
                          <Label>From Date</Label>
                          <InputGroup>
                            <Flatpickr
                              className="form-control d-block"
                              placeholder="dd M,yyyy"
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                              }}
                            />
                          </InputGroup>
                        </div>
                      </Col>
                      <Col xs={3}>
                        <div className="form-group mb-4">
                          <Label>To Date</Label>
                          <InputGroup>
                            <Flatpickr
                              className="form-control d-block"
                              placeholder="dd M,yyyy"
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                              }}
                            />
                          </InputGroup>
                        </div>
                      </Col>
                      <Col xs={3} className="mt-4">
                        <button type="submit" className="btn btn-primary w-md">
                          Submit
                        </button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>

        <div className="">
          {/* <Breadcrumbs title="Tables" breadcrumbItem="Product List" /> */}
          {/* <div className="d-flex align-items-center justify-content-start">
            <div className="flex-shrink-0 m-0 mt-0 mb-0">
              <p>
                Report of Employee Name for the date range: 1-1-2024 to 2-2-2024{" "}
              </p>
            </div>
          </div> */}
          <TableContainer
            columns={columns}
            data={data || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="27 records..."
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </React.Fragment>
  )
}
MaintainanceContactpendingexecution.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default MaintainanceContactpendingexecution
